import React from 'react';
import { AbsoluteFill } from 'remotion';
import { ThemeSystemConfig } from '../../clipCreator/remotion/Components/Theme/Theme';
import { AspectRatio } from '../AspectRatio';
import { TimelineDefaults } from '../TimelineDefaults';
import { BrandingItem, BrandingItemImpl } from '../types';
import { LayerContainer } from './types';

export class BrandingLayerContainer implements LayerContainer {
    items: BrandingItem[];

    constructor(items: Omit<BrandingItem, 'render'>[]) {
        this.items = items.map(item => new BrandingItemImpl(item));
    }

    render(fps: number, theme: ThemeSystemConfig, aspectRatio: AspectRatio, defaults: TimelineDefaults, videoConfig?: { width: number; height: number }): React.ReactNode {
        return (
            <AbsoluteFill>
                {this.items.map(item => (
                    <div key={item.id} style={{ position: 'absolute', width: '100%', height: '100%' }}>
                        {item.render(fps, theme, aspectRatio, defaults, videoConfig)}
                    </div>
                ))}
            </AbsoluteFill>
        );
    }
} 